/**
 * Helpers de ubicación y cotización SIN dependencias de mapas.
 *
 * 🪤 Estaban en `waLeafletShared.ts`, junto al código que usa Leaflet. Mezclar helpers puros con una
 * librería pesada hace que la librería sea inevitable: `WaCoverageCheckCard` sólo quería
 * `formatPEN` y `parseLatLng` y se traía **leaflet entero al arranque del panel** (~440 KB), porque
 * un import trae el módulo completo, no la función.
 *
 * Es el mismo error que ya se pagó con el barrel de `@smarty/shared` y el renderer del storefront
 * (ADR-0012, paso 4). La regla que queda: **lo puro y lo pesado no comparten archivo.**
 */

export interface QuoteZoneInput {
  districtName: string | null;
  fee: number;
  courierName?: string | null;
  courierEtaMinutes?: number | null;
}

export function parseLatLng(body: string | null | undefined): [number, number] | null {
  if (!body) return null;
  const [latStr, lngStr] = body.split(',').map((s) => s.trim());
  const lat = Number(latStr);
  const lng = Number(lngStr);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  return [lat, lng];
}
export function formatPEN(n: number | null | undefined): string {
  if (n == null || !Number.isFinite(n)) return '—';
  return `S/ ${n.toFixed(2)}`;
}
export function buildInZoneQuote(zone: QuoteZoneInput): string {
  const courierLabel = zone.courierName
    ? ` con ${zone.courierName}${zone.courierEtaMinutes ? ` (~${zone.courierEtaMinutes} min)` : ''}`
    : '';
  return (
    `¡Hola! Confirmé tu ubicación 📍\n\n` +
    `✅ Sí llegamos a tu zona${zone.districtName ? ` (${zone.districtName})` : ''}.\n` +
    `🛵 Envío: ${formatPEN(zone.fee)}${courierLabel}\n\n` +
    `¿Confirmamos el pedido?`
  );
}
export function buildOutOfZoneQuote(): string {
  return (
    `Hola, gracias por enviarnos tu ubicación 📍\n\n` +
    `Lamentablemente esta zona está fuera de nuestra cobertura de delivery actual. ` +
    `¿Tienes otra dirección donde podamos enviarte el pedido?`
  );
}
